var PubSubManager = {
  subscribers: [],

  subscribe: function(topic, parent, callback) {
    this.subscribers.push({ topic: topic, parent: parent, callback: callback });
  },

  publish: function(topic, data ) {
    // Notify subscribers of event.
    this.subscribers.forEach(function(subscriber) {
      if(subscriber["topic"] === topic) {
          subscriber.callback(subscriber.parent, data);
      }
    });
  }
};

export default PubSubManager;


// WEBPACK FOOTER //
// ./src/util/PubSubManager.js